import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface StatusButtonProps {
  status?: string;
  to: string;
}
const getButtonColor = (status?: string) => {
    switch (status) {
      case 'NOT_AVAILABLE':
        return '#9f9f9f';  // 검은색
        
      case 'IN_PROGRESS':
          return '#2282E9';  // 기본 검은색
  
        case 'COMPLETE':
          return '#2282E9';  // 파란색
          
        case 'SUBMITTED':
          return'#2282E9';  // 기본 검은색
  
        case 'APPROVED_EDITABLE':
          return '#2282E9';  // 파란색
  
        case 'APPROVED_FINAL':
          return'#2282E9';  // 파란색
  
        case 'REJECTED':
          return '#FF0000';  // 빨간색
  
        default:
          return 'black';  // 기본 검은색
    }
  };
  


const ContentBtn = styled.button<{ isAvailable: boolean, status?: string }>`
  width: 173px;
  height: 60px;
  border: 1.5px solid ${({ status }) => {
    const color = getButtonColor(status);
    return color;
  }};
  background-color: white;
  color: ${({ status }) => {
    const color = getButtonColor(status);
    return color;
  }};
  border-radius: 5px;
  font-weight: 600;
  cursor: ${({ isAvailable }) => isAvailable ? 'pointer' : 'not-allowed'};
  transition: all 0.2s;

  &:hover {
    background-color: ${({ isAvailable }) => isAvailable ? '#F8F9FA' : 'white'};
  }
`;

const getButtonText = (status?: string) => {
  switch (status) {
    case 'IN_PROGRESS':
      return '이어 작성하기';
    case 'COMPLETE':
      return '수정하기';
    case 'SUBMITTED':
      return '확인하기';
    case 'APPROVED_EDITABLE':
      return '수정하기';
    case 'APPROVED_FINAL':
      return '확인하기';
    case 'REJECTED':
      return '수정 요청';
    default:
      return '작성하기';
  }
};

const isButtonAvailable = (status?: string) => {
  return ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETE', 'SUBMITTED', 'APPROVED_EDITABLE', 'APPROVED_FINAL', 'REJECTED'].includes(status || '');
};

export const StatusButton = ({ status, to }: StatusButtonProps) => {
  return (
    <Link to={isButtonAvailable(status) ? to : "#"}>
      <ContentBtn 
        isAvailable={isButtonAvailable(status)}
        status={status}
        disabled={status === 'NOT_AVAILABLE'}
        onClick={(e) => {
          if (status === 'NOT_AVAILABLE') {
            e.preventDefault();
          }
        }}
      >
        {getButtonText(status)}
      </ContentBtn>
    </Link>
  );
}; 